import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo, LinkTo} from "../../../constants/linkTo";

export const NotificationLMSApprove: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const lmsInfo = actions[0]?.lmsHomeWorkApproveInfo;

    if (!lmsInfo) return null;

    if (lmsInfo?.isApprove && lmsInfo?.score) return <SimpleTitle>
        {`Ваша работа на тему `}
        <a href={window.location.origin + LinkTo.myCoursesGrades + `?projectId=${lmsInfo?.moduleProjectId}`}>
            "{lmsInfo?.themeTitle}"
        </a>
        {` была оценена на `}
        <span>{lmsInfo?.score}</span> 
        {` и одобрена преподавателем `}
        <a href={window.location.origin + '/designer/' + lmsInfo?.teacher?.accountId}>
            {`${lmsInfo?.teacher?.name} ${lmsInfo?.teacher?.surName}`}
        </a>
    </SimpleTitle>

    if (lmsInfo?.isApprove) return <SimpleTitle>
        {`Ваша работа на тему `}
        <a href={window.location.origin + LinkTo.myCoursesGrades + `?projectId=${lmsInfo?.moduleProjectId}`}>
            "{lmsInfo?.themeTitle}"
        </a>
        {` была проверена и одобрена преподавателем `}
        <a href={window.location.origin + '/designer/' + lmsInfo?.teacher?.accountId}>
            {`${lmsInfo?.teacher?.name} ${lmsInfo?.teacher?.surName}`}
        </a>
    </SimpleTitle>

    return <SimpleTitle>
        {`Ваша работа на тему `}
        <a href={window.location.origin + CreateLinkTo.project(lmsInfo?.moduleProjectId)}>
            "{lmsInfo?.themeTitle}"
        </a>
        {` была проверена преподавателем `}
        <a href={window.location.origin + '/designer/' + lmsInfo?.teacher?.accountId}>
            {`${lmsInfo?.teacher?.name} ${lmsInfo?.teacher?.surName}`}
        </a>
        {` и требует доработки`}
    </SimpleTitle>
}import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo, LinkTo} from "../../../constants/linkTo";

export const NotificationLMSApprove: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const lmsInfo = actions[0]?.lmsHomeWorkApproveInfo;

    if (!lmsInfo) return null;

    if (lmsInfo?.isApprove && lmsInfo?.score) return <SimpleTitle>
        {`Ваша работа на тему `}
        <a href={window.location.origin + LinkTo.myCoursesGrades + `?projectId=${lmsInfo?.moduleProjectId}`}>
            "{lmsInfo?.themeTitle}"
        </a>
        {` была оценена на `}
        <span>{lmsInfo?.score}</span> 
        {` и одобрена преподавателем `}
        <a href={window.location.origin + '/designer/' + lmsInfo?.teacher?.accountId}>
            {`${lmsInfo?.teacher?.name} ${lmsInfo?.teacher?.surName}`}
        </a>
    </SimpleTitle>

    if (lmsInfo?.isApprove) return <SimpleTitle>
        {`Ваша работа на тему `}
        <a href={window.location.origin + LinkTo.myCoursesGrades + `?projectId=${lmsInfo?.moduleProjectId}`}>
            "{lmsInfo?.themeTitle}"
        </a>
        {` была проверена и одобрена преподавателем `}
        <a href={window.location.origin + '/designer/' + lmsInfo?.teacher?.accountId}>
            {`${lmsInfo?.teacher?.name} ${lmsInfo?.teacher?.surName}`}
        </a>
    </SimpleTitle>

    return <SimpleTitle>
        {`Ваша работа на тему `}
        <a href={window.location.origin + CreateLinkTo.project(lmsInfo?.moduleProjectId)}>
            "{lmsInfo?.themeTitle}"
        </a>
        {` была проверена преподавателем `}
        <a href={window.location.origin + '/designer/' + lmsInfo?.teacher?.accountId}>
            {`${lmsInfo?.teacher?.name} ${lmsInfo?.teacher?.surName}`}
        </a>
        {` и требует доработки`}
    </SimpleTitle>
}